import React, { useState, useEffect, Link } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { update_username_orders, update_services_categorys, update_amount_orders, update_discount_order, update_comments_orders } from './actions';
import { alert_error, alert_success } from '../../AppContext';
import axios from 'axios';

function Ordergoogle({ input_url_orders, set_input_url_orders, services_math_1, commentsok, handleTextareaChange, isDisabled }) {
    const items = useSelector(state => state.items);
    const amount_orders = useSelector(state => state.amount_orders);
    const discount_orders = useSelector(state => state.discount_orders);
    const services_categorys = useSelector(state => state.services_categorys);
    const services_orders = useSelector(state => state.services_orders);
    const comments_orders = useSelector(state => state.comments_orders);
    const username_orders = useSelector(state => state.username_orders);
    const [label_text, set_label_text] = useState('');
    const [input_type, set_input_type] = useState('');
    const [input_data, set_input_data] = useState('');
    const [note_mini, set_note_mini] = useState('');

    const set_username_orders = (value) => {
        dispatch(update_username_orders(value));
    };
    const set_comments_orders = (value) => {
        dispatch(update_comments_orders(value));
    };
    const [Text, setText] = useState('');
    const dispatch = useDispatch();

    const set_amount_orders = (value) => {
        dispatch(update_amount_orders(value));
    };
    useEffect(() => {
        // Đếm số ký tự trong biến text
        let characterCount = Text.length;
        characterCount = Math.round(characterCount);
        set_amount_orders(Text.length);
        services_math_1(Text.length);
    }, [Text]);
    useEffect(() => {
        if (services_orders && services_orders.type && services_orders.type.includes("tele_ads")) {
            set_label_text("Nhóm bạn muốn ăn cắp mem");
            set_input_type("comments_orders");
            set_input_data({
                option: "input", // Corrected the typo here
                type: "text",
                placeholder: "vd: @freetiktokfb",
            });
            set_note_mini('thành viên app sẽ mời đủ mem.');
        } else if (services_orders && services_orders.type && services_orders.type.includes("traffix_banner")) {
            set_label_text("Mô tả dịch vụ bạn quảng cáo");
            set_input_type("comments_orders");
            set_input_data({
                option: "input", // Corrected the typo here
                type: "text",
                placeholder: "vd: web buff follow uy tín ...",
            });
            set_note_mini('thành viên app sẽ nhìn vô mô tả quảng cáo của bạn để click vô.');
        }
        else if (services_orders && services_orders.type && services_orders.type.includes("googlemaps")) {
            set_label_text("Mô tả dịch vụ maps bạn cung cấp");
            set_input_type("comments_orders");
            set_input_data({
                option: "input", // Corrected the typo here
                type: "text",
                placeholder: "Cửa hàng bán điện thoại iphone ở Hà Nội",
            });
            set_note_mini('thành viên app sẽ dựa theo "mô tả dịch vụ Maps bạn cung cấp" để tự nghĩ nội dung review phù hợp.');
        } else if (services_orders && services_orders.type && services_orders.type.includes("zalo_mem")) {
            set_label_text("Tên nhóm cần tăng")
            set_input_type("username_orders")
            set_input_data({
                opyion: "input",
                type: "text",
                placeholder: "ví dụ: Box anti Hust Media"
            })
            set_note_mini('Nếu thay tên nhóm khi đang chạy sẽ không hoàn Coins');
        } else if (services_orders && services_orders.type && services_orders.type.includes("vip_code")) {
            set_label_text("Từ khóa cần sale")
            set_input_type("username_orders")
            set_input_data({
                opyion: "input",
                type: "text",
                placeholder: "ví dụ: Hust Media"
            })
            set_note_mini('Chỉ tăng được trang web trong top 50 lên top 1');
        }
        else {
            set_label_text('');
            set_input_type('');
            set_input_data('');
            set_note_mini('');
        }
    }, [services_orders]); // The effect will run whenever services_orders changes
    return (
        <>
            {
                label_text && (<>
                    <label className="mt-0 mb-0 flex justify-center items-center">{label_text}</label>
                </>)
            }
            {
                (input_data && input_type) && (<>
                    <div className="input-group flex-nowrap">
                        <input
                            onChange={
                                input_type === "comments_orders"
                                    ? (e) => set_comments_orders(e.target.value)
                                    : input_type === "username_orders"
                                        ? (e) => set_username_orders(e.target.value)
                                        : undefined
                            }
                            value={
                                input_type === "comments_orders"
                                    ? comments_orders
                                    : input_type === "username_orders"
                                        ? username_orders
                                        : ""
                            }
                            type={input_data.type}
                            className="form-control mb-0"
                            placeholder={input_data.placeholder}
                            aria-label="inputcaption"
                            name="inputcaption"
                            aria-describedby="addon-wrapping"
                        ></input>
                    </div>
                </>)
            }
            {
                note_mini && (<>
                    <div className="text-sm mt-[-1px] ">{note_mini}</div>
                </>)
            }
            {(services_orders && services_orders.category && services_orders.type.includes("hust_media_tele")) && (
                <>
                    <div className="p-1">
                        <div className="mt-0 my-0 block font-medium text-sm mx-auto">
                            Bài đăng quảng cáo
                        </div>
                        <textarea
                            className="w-full h-40 border mb-0 border-gray-300 rounded p-2 resize-none"
                            placeholder="Nhập bài đăng quảng cáo..."
                            value={commentsok}
                            onChange={handleTextareaChange}
                        />
                    </div>
                </>
            )}
            {(services_orders && services_orders.type && services_orders.type.includes("Custom Comments")) && (
                <>
                    <div className="p-1">
                        <div className="mt-0 my-0 block font-medium text-sm mx-auto">
                            Số bình luận hoặc đánh giá tăng là : {amount_orders}
                        </div>
                        <textarea
                            className="w-full h-40 border mb-0 border-gray-300 rounded p-2 resize-none"
                            placeholder="Nhập đánh giá..."
                            value={commentsok}
                            onChange={handleTextareaChange}
                        />
                        <div className="text-xs mt-[-1px]">
                            {" "}
                            Tối thiểu {services_orders.minorder} &emsp; Tối đa {services_orders.maxorder}
                        </div>
                    </div>
                </>
            )}
        </>
    );
}

export default Ordergoogle;